import React, { useState, useContext } from 'react';
import classNames from 'classnames';
import { FormLabel, Button, Modal } from 'react-bootstrap';
import ModalContext from '../modal/ModalContext';
import { modal } from '../modal/ModalEmitter';

const CancelQuoteForm = () => {
  const [cancelReason, setCancelReason] = useState('');
  const { ok } = useContext(ModalContext);

  const handleConfirm = () => {
    ok(cancelReason);
  };

  return (
    <div className="cancel-quote">
      <FormLabel>
        <strong>Enter a cancel reason</strong>
      </FormLabel>
      <div className={classNames('form-textarea', { 'is-empty': !cancelReason })}>
        <textarea
          style={{
            height: '200px',
          }}
          className="form-control"
          autoFocus
          onChange={e => setCancelReason(e.target.value)}
        ></textarea>
      </div>
      <Modal.Footer className="mt-1" style={{ padding: '0px' }}>
        <div>
          <Button onClick={() => modal.close()} variant="secondary">
            Dismiss
          </Button>
          <Button onClick={handleConfirm} variant="primary">
            Confirm
          </Button>
        </div>
      </Modal.Footer>
    </div>
  );
};

export default CancelQuoteForm;
